module.exports = __webpack_public_path__ + "static/hrprimed-543216dd24ad61af567de09835325215.png";